import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';

class AcsParameterItem extends Component {

  render() {
    return (
        <div>
          <li>{this.props.location}</li>
          {this.props.index !== null && this.props.index !== undefined ? (
              <li className="pl-33">{messageConstants.ACS_INDEX}{this.props.index}
                {this.props.isDefault !== false && this.props.isDefault !== null
                && this.props.isDefault !== undefined ? " "
                    + messageConstants.ACS_DEFAULT : null}</li>) : null}
          {this.props.binding ? (
                  <li className="pl-33">{messageConstants.SLO_BINDING}{this.props.binding}</li>)
              : null}
        </div>
    );
  }
}

export default AcsParameterItem;